// /sign-in — the in-shell sign-in page reached from the logged-out top bar's
// "Sign in" button. Renders the same LoginForm as /auth/login (Welcome-back
// heading, Google SSO, email/password, second-factor step — it all works
// identically), but INSIDE the public shell so the left nav and top bar stay
// put. The /auth/login promo split-screen (AuthLayout) is dropped; the shell
// is the chrome. Mirrors /get-started, the in-shell join flow.

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Card, Container, Stack } from '@leanin/ui';
import { LoginForm } from '@/components/auth/LoginForm';
import { redirectIfSignedIn } from '@/lib/use-session';

// Same params /auth/login accepts, so this is a drop-in equivalent: an invite
// bounce token, and a drift-final `reason` the form explains. `from` is
// accepted (call sites pass it) but, as on /auth/login, not yet honored.
const signInSearchSchema = z.object({
  pendingInviteToken: z.string().min(1).optional(),
  from: z.string().optional(),
  reason: z.enum(['deactivated_expired', 'restricted']).optional(),
});

export const Route = createFileRoute('/_public/sign-in')({
  validateSearch: signInSearchSchema.parse,
  // Already signed in? Nothing to do here — go to the feed (same as
  // /auth/login). The _public layout renders the anonymous shell around this.
  beforeLoad: ({ context }) => redirectIfSignedIn(context),
  component: SignInPage,
});

function SignInPage() {
  const { pendingInviteToken, reason } = Route.useSearch();
  return (
    <Container max="lg" py="page" px="lg">
      <Stack align="center">
        <Card style={{ width: '100%', maxWidth: 440 }}>
          <LoginForm
            createAccountHref="/get-started"
            {...(pendingInviteToken !== undefined ? { pendingInviteToken } : {})}
            {...(reason !== undefined ? { driftReason: reason } : {})}
          />
        </Card>
      </Stack>
    </Container>
  );
}
